"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var InMemoryCollection = /** @class */ (function () {
    function InMemoryCollection(uniqueKey) {
        this.items = {};
        this.uniqueKey = uniqueKey;
    }
    InMemoryCollection.prototype.upsert = function (item) {
        this.items[item[this.uniqueKey]] = __assign(__assign({}, this.items[item[this.uniqueKey]]), item);
        return item;
    };
    InMemoryCollection.prototype.find = function (id) {
        return this.items[id];
    };
    InMemoryCollection.prototype.remove = function (id) {
        delete this.items[id];
    };
    InMemoryCollection.prototype.findBy = function (filter) {
        return Object.values(this.items).find(function (item) {
            return Object.keys(filter).every(function (filterKey) { return filter[filterKey] === item[filterKey]; });
        });
    };
    InMemoryCollection.prototype.sort = function (key, dir) {
        if (dir === void 0) { dir = 'asc'; }
        return Object.values(this.items).sort(function (i1, i2) { return i1[key] > i2[key] ? (dir === 'asc' ? 1 : -1) : (dir === 'asc' ? -1 : 1); });
    };
    return InMemoryCollection;
}());
exports.default = InMemoryCollection;
//# sourceMappingURL=InMemoryCollection.js.map